/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentModels } from '../../models/document-models';

export interface ExportDocumentsDetail$Params {
  Id?: number;
}

export function exportDocumentsDetail(http: HttpClient, rootUrl: string, params?: ExportDocumentsDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentModels>> {
  const rb = new RequestBuilder(rootUrl, exportDocumentsDetail.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentModels>;
    })
  );
}

exportDocumentsDetail.PATH = '/exportdocument/getdetails';
